import React from "react";
import "../../styles/PlacementNetworking.css"; 
import Professional from "../../assets/Profeesional.jpeg";
import Accounting from "../../assets/Accounting.jpeg";
import GST from "../../assets/GST.jpeg";
import Communication from "../../assets/Communication.jpeg";
import Study from "../../assets/Study.jpeg";
import FixedDate from "../../assets/FixedDate.jpeg";
import IndustryConnect from "../../assets/IndustryConnect.jpeg";
import ExamGuidance from "../../assets/ExamGuidance.jpeg";


const AddOnCourses = () => {
  // Section 1: Add-On Courses Data
  const coursesData = [
    {
      id: 1,
      title: "Professional Courses",
      desc: "CA, CMA, CS, ACCA",
      img: Professional,
    },
    {
      id: 2,
      title: "Accounting Software Training",
      desc: "Tally Prime, Zoho Books, QuickBooks",
      img: Accounting,
    },
    {
      id: 3,
      title: "GST & Taxation",
      desc: "Practical training from industry experts",
      img: GST ,
    },
    {
      id: 4,
      title: "Communication & Soft Skills",
      desc: "Career-focused sessions",
      img: Communication,
    }
  ];

  // Section 2: Special Benefits Data
  const benefitsData = [
    {
      id: 1,
      title: "Study Anywhere",
      desc: "Attend classes from your home.",
      img: Study ,
    },
    {
      id: 2,
      title: "No Fixed Start Date",
      desc: "Flexible batch joining",
      img: FixedDate,
    },
    {
      id: 3,
      title: "Industry Connect",
      desc: "Guest lectures from finance & corporate professionals.",
      img: IndustryConnect ,
    },
    {
      id: 4,
      title: "100% Exam Guidance",
      desc: "Mock tests & doubt-clearing sessions.",
      img:ExamGuidance,
    }
  ];

  return (
    <section className="addon-section container">
      
      {/* --- SECTION 1: Add-On Courses --- */}
      <h2 className="addon-main-title text-center">
        Add-On Courses for Degree Students
      </h2>

      <div className="addon-grid mb-5">
        {coursesData.map((item) => (
          <div key={item.id} className="addon-card">
            {/* Image */}
            <div className="addon-img-box">
              <img src={item.img} alt={item.title} className="addon-img" />
            </div>
            {/* Content */}
            <div className="addon-content">
              <h5 className="addon-title">{item.title}</h5>
              <p className="addon-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* --- SECTION 2: Special Benefits --- */}
      <h2 className="addon-main-title text-center mt-5">
        Special Benefits
      </h2>

      <div className="addon-grid">
        {benefitsData.map((item) => (
          <div key={item.id} className="addon-card">
            {/* Image */}
            <div className="addon-img-box">
              <img src={item.img} alt={item.title} className="addon-img" />
            </div>
            {/* Content */}
            <div className="addon-content">
              <h5 className="addon-title">{item.title}</h5>
              <p className="addon-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default AddOnCourses;